import { RefreshIcon } from '@heroicons/react/solid'
import { getErrorString } from 'src/utils'
import { ErrorTemplate } from './Template'
import CustomButton from '../Shared/UIComponents/Button'

type Props = {
  message: unknown
  onClick: () => void
}

export function ErrorApi(props: Props) {
  return (
    <ErrorTemplate
      title="An error occurred"
      message={getErrorString(props.message)}
      button={
        <CustomButton
          onClick={props.onClick}
          label="Reload"
          icon={<RefreshIcon />}
          iconPosition="left"
        />
      }
    />
  )
}
